module.exports = __webpack_public_path__ + "static/genome-f8bc9906fe06e7d5209dcc3b6372424d.jpg";